import * as Immutable from "immutable";
import { BaseEntity } from "../../baseEntity";
import { Panel } from "./panel";
import { AttributeControl } from './attributeControl';

export class AttributePanel extends Panel {

  protected readonly HIDE_ATTRIBUTES_WITH_EMPTY_VALUES = "hideAttributesWithEmptyValues";
  protected readonly HIDE_EMPTY_PANEL = "hideEmptyPanel";
  protected readonly ITEMS = "items";

  get hideAttributesWithEmptyValues(): boolean { return this.getInternalValue<boolean>(this.HIDE_ATTRIBUTES_WITH_EMPTY_VALUES); }
  setHideAttributesWithEmptyValues(hideAttributesWithEmptyValues: boolean): this { return this.setInternalValue(this.HIDE_ATTRIBUTES_WITH_EMPTY_VALUES, hideAttributesWithEmptyValues); }

  get hideEmptyPanel(): boolean { return this.getInternalValue<boolean>(this.HIDE_EMPTY_PANEL); }
  setHideEmptyPanel(hideEmptyPanel: boolean): this { return this.setInternalValue(this.HIDE_EMPTY_PANEL, hideEmptyPanel); }

  get items(): Immutable.List<AttributeControl> { return this.getInternalValue<Immutable.List<AttributeControl>>(this.ITEMS); }
  setItems(value: Immutable.List<AttributeControl>): this { return this.setInternalValue(this.ITEMS, value); }

}